/**
 * Stack routes of the native screens added by the `finance` admin-module group
 * (its module defs live in system.js; only routes + locales + screens are separate).
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'FinanceListScreen', component: lazyScreen(() => import('../../screens/adminModules/finance/FinanceListScreen'))},
    {name: 'FinanceAiStatsScreen', component: lazyScreen(() => import('../../screens/adminModules/finance/AiStatsScreen'))},
    {name: 'FinanceInvoiceParserScreen', component: lazyScreen(() => import('../../screens/adminModules/finance/InvoiceParserScreen'))},
];

export default ROUTES;
